import Assert from "./Assert"

export default function Delay(ms: number): Promise<void>{
  Assert.isTrue( !isNaN(ms) &&  ms >= 0, `Invalid Delay ${ms}` )

  return new Promise<void>( (resolve)=>{
    setTimeout( resolve, ms )
  })
}